import { SvgIcon, type SvgIconProps } from './svgIcon'

export function CrownIcon({ width = 15, height = 15, ...props }: SvgIconProps) {
  return (
    <SvgIcon width={width} height={height} viewBox="0 0 16 14" {...props}>
      <g clipPath="url(#clip0_204_8173)">
        <path
          d="M8.58333 2.89844C8.9 2.70703 9.11111 2.35977 9.11111 1.96875C9.11111 1.36445 8.61389 0.875 8 0.875C7.38611 0.875 6.88889 1.36445 6.88889 1.96875C6.88889 2.3625 7.1 2.70703 7.41667 2.89844L5.825 6.03203C5.57222 6.52969 4.91667 6.67188 4.475 6.32461L2 4.375C2.13889 4.1918 2.22222 3.96484 2.22222 3.71875C2.22222 3.11445 1.725 2.625 1.11111 2.625C0.497222 2.625 0 3.11445 0 3.71875C0 4.32305 0.497222 4.8125 1.11111 4.8125C1.11667 4.8125 1.125 4.8125 1.13056 4.8125L2.4 11.6867C2.55278 12.518 3.28889 13.125 4.15 13.125H11.85C12.7083 13.125 13.4444 12.5207 13.6 11.6867L14.8694 4.8125C14.875 4.8125 14.8833 4.8125 14.8889 4.8125C15.5028 4.8125 16 4.32305 16 3.71875C16 3.11445 15.5028 2.625 14.8889 2.625C14.275 2.625 13.7778 3.11445 13.7778 3.71875C13.7778 3.96484 13.8611 4.1918 14 4.375L11.525 6.32461C11.0833 6.67188 10.4278 6.52969 10.175 6.03203L8.58333 2.89844Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_204_8173">
          <rect width="16" height="14" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
